module.exports = function runningNodeJs() {
	return typeof module !== 'undefined' && typeof window === 'undefined';
};